import { PpfRouteData } from "@ppf/shared/data";

const baseRoute = "pre-proposal";

export const PRE_PROPOSAL_ROUTE_DATA: PpfRouteData = {
	base: {
		route: baseRoute,
		fullRoute: `/${baseRoute}`,
	},
	start: {
		route: "start",
		fullRoute: `/${baseRoute}/start`,
	},
	address: {
		route: "address",
		fullRoute: `/${baseRoute}/address`,
	},
	bill: {
		route: "bill",
		fullRoute: `/${baseRoute}/bill`,
	},
	contact: {
		route: "contact",
		fullRoute: `/${baseRoute}/contact`,
	},
	error: {
		route: "error",
		fullRoute: `/${baseRoute}/error`,
	},
};
